import Vue from 'vue';
import SweetUI from '@sweet/ui';
import '@sweet/ui-reboot/dist/index.css';
import '@sweet/ui/dist/index.css';
import '@sweet/ui-utils/dist/index.css';
import '@/styles/index.scss';
import Components from '@/components';

Vue.use(SweetUI);
Vue.use(Components);

export default SweetUI;
